<script>
import gsap from "gsap";

export default {
  name: "Contact",
  setup() {
    const { t } = useI18n();
    const route = useRoute();

		// useSeoMeta({
		// 	title: t("contact.meta.title"),
		// 	ogTitle: t("contact.meta.title"),
    //   description: t("contact.meta.description"),
    //   ogUrl: route.fullPath,
    //   ogImage: "https://www.opero.cz/img/5_kontakt.jpg",
		// })

    useHeadMeta({
      title: t("contact.meta.title"),
      description: t("contact.meta.description"),
      url: route.fullPath,
      csUrl: 'cs/kontakt',
      enUrl: 'en/contact',
      image: "https://www.opero.cz/img/5_kontakt.jpg",
      alt: "Opero",
    });
  },

  data() {
    return {
      cursor: "",
      cursorStyle: {},
      width: 1365,
      xTo: null,
      yTo: null,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);

    this.width =
      document.body.clientWidth ||
      window.innerWidth ||
      document.documentElement.clientWidth;

    if (this.width > 1024) {
      window.addEventListener("mousemove", this.mouseMove);
      gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

      this.xTo = gsap.quickTo("#cursor", "x", {
        duration: 0.1,
        ease: "power3",
      });
      this.yTo = gsap.quickTo("#cursor", "y", {
        duration: 0.1,
        ease: "power3",
      });
    }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("mousemove", this.mouseMove);
    window.document.removeEventListener("click", this.cursorOnClick);
  },
  methods: {
    setCursor(value, onClick, style) {
      this.cursor = value;
      if (this.cursorOnClick !== onClick) {
        window.document.removeEventListener("click", this.cursorOnClick);
        this.cursorOnClick = onClick;

        window.document.addEventListener("click", this.cursorOnClick);
      }
      if (this.cursorStyle !== style) {
        this.cursorStyle = style;
      }
    },
    cursorOnClick: () => {},
    mouseMove(e) {
      if (this.width > 1024 && this.xTo && this.yTo) {
        this.xTo(e.pageX);
        this.yTo(e.pageY);
      }
    },
    handleScroll(e) {},
    handleResize() {
      this.width =
        document?.body?.clientWidth ||
        window?.innerWidth ||
        document?.documentElement?.clientWidth;
      if (this.width > 1024) {
        gsap.set("#cursor", { xPercent: -50, yPercent: -50 });

        this.xTo = gsap.quickTo("#cursor", "x", {
          duration: 0.1,
          ease: "power3",
        });
        this.yTo = gsap.quickTo("#cursor", "y", {
          duration: 0.1,
          ease: "power3",
        });
      }
    },
  },
};
</script>

<template>
  <div @mousemove="mouseMove">
    <div>
      <ContactHeader
        :set-cursor="setCursor"
      />
      

      <div class="mb-12 lg:mb-24">
        <template v-if="false">
          <OperoGoogleMap />
        </template>

          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2559.861581951758!2d14.418205377727759!3d50.08887837152561!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470b94e9078eebbf%3A0x20428f18a4bedbf6!2sOpero%20Business%20hub%20a%20coworking!5e0!3m2!1scs!2scz!4v1762268530880!5m2!1scs!2scz" width="600" height="450" style="border:0; width: 100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>

      <div
        class="flex justify-center mb-24 mt-24"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': -1,
          })
        "
      >
        <div class="max-w-7xl flex justify-center w-full">
          <div
            class="grid px-6 md:grid-cols-3 gap-12 content-center text-center md:text-left"
          >
            <div class="font-light">
              <h3 class="txt-q pb-3">{{ $t("contact.openHours") }}</h3>
              <div>{{ $t("homepage.footer.openHours.part1") }}</div>
              <div>{{ $t("homepage.footer.openHours.part2") }}</div>
            </div>
            <div class="font-light">
              <h3 class="txt-q pb-3">{{ $t("contact.whereToFind") }}</h3>
              <div><b>Opero s.r.o.</b></div>
              <div>Salvátorská 931/8</div>
              <div>Staré Město,</div>
              <div>110 00, Praha 1</div>
            </div>
            <div class="font-light">
              <h3 class="txt-q pb-3">{{ $t("contact.bankConnect") }}</h3>
              <div v-html="$t('contact.banking-details')"></div>
            </div>
          </div>
        </div>
      </div>

			<ContactPersons :set-cursor="setCursor" />

      <div
        class="flex justify-center mt-12 mb-12 lg:mt-24 lg:mb-32"
        @mouseenter="
          setCursor(null, null, {
            'font-size': '14px',
            background: '#FFC800',
            width: '25px',
            height: '25px',
            'z-index': -1,
          })
        "
      >
        <div class="max-w-7xl w-full">
          <div class="txt-q text-center mb-12">
            {{ $t("contact.socials") }}
          </div>
          <div class="flex justify-center gap-4">
            <a
              target="_blank"
              href="https://www.facebook.com/operoPrague"
              rel="noopener noreferrer"
            >
              <img src="../assets/Facebook.svg" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://instagram.com/opero_prague?igshid=MzRlODBiNWFlZA=="
            >
              <img src="../assets/Instagram.svg" />
            </a>
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://www.linkedin.com/company/operoprague/"
            >
              <img src="../assets/LinkedIn.svg" />
            </a>
          </div>
        </div>
      </div>
      <Footer :set-cursor="setCursor" />
    </div>
    <div
      id="cursor"
      class="hidden cursor-auto lg:cursor-none lg:flex pointer-events-none"
      :style="cursorStyle"
      :class="{
        smallCursor: cursor === null,
      }"
      @click="cursorOnClick"
      v-html="cursor"
    ></div>
  </div>
</template>

<style scoped lang="scss">
.l-map {
  height: 400px;
  width: 100%;
}

.map-container {
  width: 100%;
  @media screen and (min-width: 2000px) {
    max-width: 1280px;
  }
}

.hide-map-bar {
  height: 72px;
  width: 100%;
  background-color: white;
  position: absolute;
  top: -10px;
}
.relative {
  position: relative;
}

#cursor {
  position: absolute;
  top: 0;
  left: -10px;
  width: 25px;
  height: 25px;
  display: none;
  font-weight: 400;

  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 50%;
  z-index: 1;
  cursor: none;
  transition:
    width 0.3s,
    height 0.3s,
    background-color 0.3s;
  transform: translate(-50%, -50%) translate(-150px, -150px);
  //pointer-events: none;
  text-align: center;
  @media screen {
    @media (pointer: fine) {
      display: flex;
    }
  }
}

.smallCursor {
  width: 20px;
  height: 20px;
  background-color: $color-primary;
}
</style>
